export const handleMultipleTablesCase = (
  relationships: any,
  setAlert: any
): string | undefined => {
  if (!relationships || relationships.length === 0) {
    setAlert({ severity: 'warning', message: 'No table relationships found.' });
    return;
  }

  const { table1, table2, relationship, isDirect } = relationships[0];
  if (!isDirect) {
    setAlert({ severity: 'warning', message: 'Tables must be in a direct relationship.' });
    return;
  }

  let targetTableId: string;

  if (relationship === 'one to many') {
    targetTableId = table2;
  } else if (relationship === 'many to one' || relationship === 'one to one') {
    targetTableId = table1;
  } else {
    setAlert({ severity: 'warning', message: 'Invalid table relationship.' });
    return;
  }

  return targetTableId;
};